import { tokens } from "./tokens";

/**
 * Tailwind `theme.extend` fragment derived from the canonical tokens.
 * Consumers (packages/ui, apps) merge this into their Tailwind config —
 * design-tokens itself has no Tailwind runtime dependency.
 */
export const tailwindThemeExtend = {
  colors: {
    primary: tokens.color.primary,
    secondary: tokens.color.secondary,
    accent: tokens.color.accent,
    background: tokens.color.background,
    text: tokens.color.text,
    "text-muted": tokens.color["text-muted"],
    success: tokens.color.success,
    warning: tokens.color.warning,
    danger: tokens.color.danger,
    "ai-marker": tokens.color["ai-marker"],
  },
  fontFamily: {
    sans: [tokens.type.family.sans],
    heading: [tokens.type.family.heading],
    body: [tokens.type.family.body],
  },
  fontSize: {
    xs: tokens.type.xs,
    sm: tokens.type.sm,
    base: [tokens.type.base, { lineHeight: String(tokens.type.lineHeight.body) }],
    lg: tokens.type.lg,
    xl: tokens.type.xl,
    "2xl": tokens.type["2xl"],
    "3xl": tokens.type["3xl"],
  },
  fontWeight: {
    light: String(tokens.type.weights[0]),
    normal: String(tokens.type.weights[1]),
    medium: String(tokens.type.weights[2]),
    semibold: String(tokens.type.weights[3]),
    bold: String(tokens.type.weights[4]),
  },
  spacing: {
    1: tokens.space[1],
    2: tokens.space[2],
    3: tokens.space[3],
    4: tokens.space[4],
    6: tokens.space[6],
    8: tokens.space[8],
    12: tokens.space[12],
    16: tokens.space[16],
  },
  boxShadow: {
    none: tokens.elevation[0] === "none" ? "none" : tokens.elevation[0],
    1: tokens.elevation[1],
    2: tokens.elevation[2],
    3: tokens.elevation[3],
    4: tokens.elevation[4],
  },
  transitionDuration: {
    fast: tokens.motion.duration.fast,
    base: tokens.motion.duration.base,
    slow: tokens.motion.duration.slow,
  },
  transitionTimingFunction: {
    enter: tokens.motion.easing.enter,
    exit: tokens.motion.easing.exit,
  },
  screens: {
    sm: tokens.breakpoint.sm,
    md: tokens.breakpoint.md,
    lg: tokens.breakpoint.lg,
    xl: tokens.breakpoint.xl,
  },
  height: {
    "table-row": tokens.size["table-row-height"],
    header: tokens.size["header-height"],
  },
  width: {
    sidebar: tokens.size["sidebar-width"],
  },
  zIndex: {
    base: String(tokens.z.base),
    dropdown: String(tokens.z.dropdown),
    modal: String(tokens.z.modal),
    toast: String(tokens.z.toast),
  },
} as const;
